import React from 'react';
import { Select } from 'antd';
import { useAtom } from 'jotai';
import { useSelector } from 'react-redux';
import { isAdminRoleSelector } from '@src/store/common/selectors';
import { useQuery } from '@tanstack/react-query';
import { getSPIThresholds } from '@src/api/SPI';
import { selectedKpiIdAtom } from '../atoms';
import { StyledConfigLabel } from './styled';

const KpiSelector = () => {
  const [selectedKpiId, setSelectedKpiId] = useAtom(selectedKpiIdAtom);
  const isAdminUser = useSelector(isAdminRoleSelector);
  const { data, isLoading, isError } = useQuery(['kpi-list'], () => getSPIThresholds({}), {
    refetchOnWindowFocus: false,
  });
  const options = (data?.data?.kpiThresholds ?? []).map((kpi) => ({
    label: kpi.kpiName,
    value: kpi.kpiID,
  }));

  return (
    <div style={{ padding: '12px 0' }}>
      <StyledConfigLabel style={{ marginRight: 12 }}>KPI</StyledConfigLabel>
      <Select
        value={selectedKpiId}
        style={{ width: 220 }}
        options={options}
        loading={isLoading}
        disabled={!isAdminUser || isLoading || isError}
        onChange={(value) => setSelectedKpiId(value as number)}
      />
      {isError && (
        <div role="alert">Unable to load KPIs. Reopen AI Alerts configuration to retry.</div>
      )}
    </div>
  );
};

export default KpiSelector;
